import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';

interface FieldProps {
  label?: string;
  hint?: string;
  error?: string | null;
  /**
   * 札（Pills・Segmented）やボタンの並びを包むとき true。<label> で包むと、
   * 見出しを押しただけで中の先頭のボタンが押されるため、div にする。
   */
  group?: boolean;
  children: React.ReactNode;
}

export const Field: React.FC<FieldProps> = ({ label, hint, error, group, children }) => {
  const Tag = group ? 'div' : 'label';
  return (
    <Tag className="v2-field" role={group ? 'group' : undefined} aria-label={group ? label : undefined}>
      {label && (
        <span className="v2-label">
          {label}
          {hint && <small>{hint}</small>}
        </span>
      )}
      {children}
      <AnimatePresence>
        {error && (
          <motion.span
            className="v2-error"
            initial={{ opacity: 0, height: 0, x: -6 }}
            animate={{ opacity: 1, height: 'auto', x: [0, -4, 4, 0] }}
            exit={{ opacity: 0, height: 0 }}
          >
            {error}
          </motion.span>
        )}
      </AnimatePresence>
    </Tag>
  );
};

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  icon?: React.ReactNode;
}

export const TextInput = React.forwardRef<HTMLInputElement, InputProps>(({ icon, className, ...rest }, ref) => (
  <span className="v2-input-wrap">
    {icon}
    <input ref={ref} className={['v2-input', className].filter(Boolean).join(' ')} {...rest} />
  </span>
));
TextInput.displayName = 'TextInput';

export const TextArea = React.forwardRef<HTMLTextAreaElement, React.TextareaHTMLAttributes<HTMLTextAreaElement>>(
  ({ className, ...rest }, ref) => <textarea ref={ref} className={['v2-textarea', className].filter(Boolean).join(' ')} {...rest} />,
);
TextArea.displayName = 'TextArea';
